<div class="dialog-wrapper">
  <h2 mat-dialog-title>{{ "brand.campaign.editName.title" | translate }}</h2>
  <mat-dialog-content>
    <div>
      <mat-form-field class="fieldset">
        <mat-label>{{
          "brand.campaign.editName.namePlaceholder" | translate
        }}</mat-label>
        <input
          matInput
          [(ngModel)]="campaignName"
          name="campaignName"
          type="text"
          required
        />
        <mat-error class="campaign_name-error">
          {{ "brand.campaign.editName.nameRequired" | translate }}
        </mat-error>
      </mat-form-field>
    </div>
  </mat-dialog-content>
  <mat-dialog-actions>
    <button class="button-white" [mat-dialog-close]="" [disabled]="saving">
      {{ "shared.cancel" | translate }}
    </button>
    <button
      class="button-orange"
      (click)="updateCampaignName()"
      [disabled]="saving || !campaignName"
    >
      <span *ngIf="saving">{{ "shared.saving" | translate }}</span>
      <span *ngIf="!saving">{{ "shared.save" | translate }}</span>
    </button>
  </mat-dialog-actions>
</div>
